import { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./OccupationCategoriesUIHelpers";

const OccupationCategoriesUIContext = createContext();

export function useOccupationCategoriesUIContext() {
  return useContext(OccupationCategoriesUIContext);
}

export const OccupationCategoriesUIConsumer = OccupationCategoriesUIContext.Consumer;

export function OccupationCategoriesUIProvider({ categoriesUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewCategoryPage: categoriesUIEvents.openNewCategoryPage,
    openEditCategoryPage: categoriesUIEvents.openEditCategoryPage
  };

  return (
    <OccupationCategoriesUIContext.Provider value={value}>
      {children}
    </OccupationCategoriesUIContext.Provider>
  );
}